// Deployment Stages
export const STAGES = {
  DEV: 'dev',
  UAT: 'uat',
  PROD: 'prod',
} as const;

export type Stage = (typeof STAGES)[keyof typeof STAGES];

/** Check if the stage is production */
export const isProd = (stage: string): boolean => stage === STAGES.PROD;

// Invoice States
export const INVOICE_STATES = {
  INGESTED: 'INGESTED',
  PROCESSING: 'PROCESSING',
  REVIEW: 'REVIEW',
  APPROVAL: 'APPROVAL',
  APPROVED: 'APPROVED',
  SYNCED: 'SYNCED',
  REJECTED: 'REJECTED',
  ON_HOLD: 'ON_HOLD',
  FAILED: 'FAILED',
  SYNC_FAILED: 'SYNC_FAILED',
  DUPLICATE_FILE: 'DUPLICATE_FILE',
} as const;

export const INVOICE_STATE_LABELS: Record<string, string> = {
  INGESTED: 'Ingested',
  PROCESSING: 'Processing',
  REVIEW: 'Pending Review',
  APPROVAL: 'Awaiting Approval',
  APPROVED: 'Approved',
  SYNCED: 'Synced to QuickBooks',
  REJECTED: 'Rejected',
  ON_HOLD: 'On Hold',
  FAILED: 'Failed',
  SYNC_FAILED: 'Sync Failed',
  DUPLICATE_FILE: 'Duplicate File',
};

// User Roles
export const USER_ROLES = {
  VIEWER: 'viewer',
  CLERK: 'clerk',
  APPROVER: 'approver',
  MANAGER: 'manager',
  ADMIN: 'admin',
} as const;

export const USER_ROLE_LABELS: Record<string, string> = {
  viewer: 'Viewer',
  clerk: 'AP Clerk',
  approver: 'Approver',
  manager: 'AP Manager',
  admin: 'Administrator',
};

// Supported Languages
export const LANGUAGES = {
  EN: 'en',
  FR: 'fr',
  ES: 'es',
} as const;

export const LANGUAGE_LABELS: Record<string, string> = {
  en: 'English',
  fr: 'Français',
  es: 'Español',
};

// Supported Currencies
export const CURRENCIES = {
  USD: 'USD',
  CAD: 'CAD',
  MXN: 'MXN',
} as const;

export const CURRENCY_LABELS: Record<string, string> = {
  USD: 'US Dollar',
  CAD: 'Canadian Dollar',
  MXN: 'Mexican Peso',
};

export const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '$',
  CAD: 'CA$',
  MXN: 'MX$',
};

// Subscription Tiers
export const SUBSCRIPTION_TIERS = {
  FREE: 'free',
  STARTER: 'starter',
  PROFESSIONAL: 'professional',
  ENTERPRISE: 'enterprise',
} as const;

// File Constraints
export const FILE_CONSTRAINTS = {
  MAX_SIZE_BYTES: 25 * 1024 * 1024, // 25MB
  ALLOWED_TYPES: ['application/pdf'],
  ALLOWED_EXTENSIONS: ['.pdf'],
} as const;

// Confidence Thresholds
export const CONFIDENCE_THRESHOLDS = {
  HIGH: 0.95,
  MEDIUM: 0.85,
  LOW: 0.7,
} as const;

// Authentication Constraints
export const AUTH_CONSTRAINTS = {
  MIN_PASSWORD_LENGTH: 8,
} as const;
